import { FeatureFlagProvider } from '@Providers/FeatureFlagsProvider';
import { DesignSchemaProvider } from '@Providers/DesignSchemaProvider';
import { TranslationProvider } from '@Providers/TranslationProvider';
import { Normalizer } from '../styles/Normalizer';
import { Router } from './Routes';
import { type DesignSchemaType } from '../middlewares/PhotonRequest';
import { type PageSchemaType } from '@Src/middlewares/CustomPageTypes';
import { CustomPageSchemaProvider } from '@Providers/CustomPageSchemaProvider';
import ErrorBoundary from './ErorrBoundary';
import CookieConsent from './CookieConsent';
import { ConfigProvider, type ConfigType } from '@Src/providers/ConfigProvider';
import { Provider } from 'react-redux';
import { store } from '@Src/store';
import ThemeProvider from '@Src/providers/ThemeProvider';

interface AppProps {
  featureFlags?: SplitIO.Treatments;
  designSchema: DesignSchemaType;
  customPageSchema: PageSchemaType;
  appConfig: ConfigType;
  translations: Record<string, string>;
}

const App = (props: AppProps): JSX.Element => (
  <ErrorBoundary identifier="base app">
    <ConfigProvider config={props.appConfig}>
      <Provider store={store}>
        <TranslationProvider translations={props.translations}>
          <DesignSchemaProvider schema={props.designSchema}>
            <CustomPageSchemaProvider schema={props.customPageSchema}>
              <ThemeProvider
                primaryFont={props.designSchema?.globalStyle?.fonts?.primary}
                secondaryFont={
                  props.designSchema?.globalStyle?.fonts?.secondary
                }
                primaryColor={props.designSchema?.appDesignScheme?.Primary}
              >
                <FeatureFlagProvider features={props.featureFlags}>
                  <>
                    <Normalizer />
                    <CookieConsent />
                    <Router />
                  </>
                </FeatureFlagProvider>
              </ThemeProvider>
            </CustomPageSchemaProvider>
          </DesignSchemaProvider>
        </TranslationProvider>
      </Provider>
    </ConfigProvider>
  </ErrorBoundary>
);

export default App;
